"use client";

import NextLink from "next/link";
import type { ComponentProps } from "react";
import { useTranslation } from "@/lib/i18n/LanguageContext";
import { localePath } from "@/lib/i18n/localePath";

type Props = ComponentProps<typeof NextLink>;

/**
 * Drop-in replacement for `next/link` that prefixes internal paths with the
 * active locale (`/preise` -> `/en/preise`). Prefer this over `next/link` so no
 * new link can forget the prefix. All rules, including German-only legal pages,
 * live in `localePath`.
 */
export default function LocaleLink({ href, ...rest }: Props) {
  const { locale } = useTranslation();
  const resolved = typeof href === "string" ? localePath(href, locale) : href;
  return <NextLink href={resolved} {...rest} />;
}

export { LocaleLink as Link };
